import store from 'alzata.ui.vue/store';

import { getJson, getAuthenticationStatus } from '../apis/streib';

store.apiClient = {
    getJson,
    getAuthenticationStatus,
};

store.initialLoad = async function () {
    await new Promise(resolve => setTimeout(resolve, 200));
};


store.registerModule('assembly', {
    namespaced: false,

    state: () => ({
        partList: [],
        laborList: [],
        permitList: [],
        equipmentList: [],
        error: '',
    }), 

    mutations: {
        setPartList(state, newList) {
            state.partList = [...newList]
        },
        setLaborList(state, newList) {
            state.laborList = [...newList]
        },
        setPermitList(state, newList) {
            state.permitList = [...newList]
        },
        setEquipmentList(state, newList) {
            state.equipmentList = [...newList]
        },
        setAssemblyError(state, newVal) {
            state.error = newVal
        }
    }

    
});

export default store;